import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';

export default Vue.component('logout-all-devices', {
  template: require('./template.html'),
  name: 'logout-all-devices',
  mixins: [guid],
  computed: {
    ...mapGetters(['currentUser', 'userAttributes']),
  },
  data() {
    return {
      loading: false,
      sendErrors: false,
    };
  },
  props: ['toggle-modal', 'modal'],
  methods: {
    async logoutAll() {
      this.loading = true;
      this.sendErrors = false;
      try {
        await this._SEND([{
          name: 'signoutAllDevices',
        }]);
        this.closeModal('logoutAll');
        this.$store.dispatch('addNotification', {
          id: this.guid(),
          type: 'success',
          message: 'Successfully logged out all device sessions.',
        });
      } catch (e) {
        this.$log.error(e.message || e);
        this.sendErrors = `${e.message || e}. This has been reported.`;
        await this._reportError({
          error: e,
          fn: 'logoutAll',
        });
      } finally {
        this.loading = false;
      }
    },
    closeModal(type) {
      this.$emit('toggle-modal', type, 'child');
    },
    formatErrors(arr) {
      return arr.join(' ');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/account/security/devices/logout-all-devices/index.js